import { gql } from "@apollo/client";
/**
 * Daily Receipts Report
 */
export const GET_DAILY_RECEIPTS = gql`
  query GetDailyReceipts(
    $date: String!
    $temple_id: String
    $groupBy: String
  ) {
    getDailyReceipts(
      date: $date
      temple_id: $temple_id
      groupBy: $groupBy
    ) {
      name
      total_amount
      count
      seva_type_id
      devoteeName
      gothram
      amount
      paymentMode
      phoneNumber
      createdBy
      temple_id
      bookingId
    }
  }
`;


/**
 * Donors Report
 */
export const GET_DONORS_REPORT = gql`
  query GetDonorsReport(
    $typeId: ID!
    $reportType: String
    $fromDate: String!
    $toDate: String!
  ) {
    getDonorsReport(
      typeId: $typeId
      reportType: $reportType
      fromDate: $fromDate
      toDate: $toDate
    ) {
      devotee_id
      devotee_name
      phone_number
      total_amount
      count
      last_date
    }
  }
`;

/**
 * Balance Sheet Report
 */
export const GET_BALANCE_SHEET = gql`
  query GetBalanceSheet(
    $fromDate: String!
    $toDate: String!
    $temple_id: String
  ) {
    getBalanceSheet(
      fromDate: $fromDate
      toDate: $toDate
      temple_id: $temple_id
    ) {
      opening_balance
      inflows
      outflows
      closing_balance
    }
  }
`;


/**
 * Devotee By SevaType Report
 */
export const GET_DEVOTEE_BY_SEVA_TYPE_REPORTS = gql`
  query getDevoteesBySevaType(
    $fromDate: String!
    $toDate: String!
    $seva_type_id: ID!
  ) {
    getDevoteesBySevaType(
      fromDate: $fromDate
      toDate: $toDate
      seva_type_id: $seva_type_id
    ) {
     pooja_booking_id
     receipt_id
     receipt_number
     pooja_datetime
     amount
     seva_name
     devotee_id
     devotee_name
     phone
     address
     gotram
    }
  }
`;


export const GET_TEMPLE_DASHBOARD_REPORTS = gql`
  query GetTempleDashboardData(
    $current_date: String!
  ) {
    getTempleDashboardData(
      current_date: $current_date
    ) {
      current_date
      count_of_bookings
      count_of_upcoming_bookings
      total_donations
      donation_items
      count_of_seva_types
    }
  }
`;




export const GET_BOOKING_SEVA_REPORTS = gql`
  query GetBookingSevaReports(
    $current_date: String!
    $range_type: String!
    $temple_name: String
  ) {
    getBookingSevaReports(
      current_date: $current_date
      range_type: $range_type
      temple_name: $temple_name
    ) {
      seva_type_id
      temple_id
      temple_name
      seva_name
      booking_count
    }
  }
`;
